<template>
  <SPSliderSection
    class="our-pride-section"
    :title="title"
    :data="students"
    :class="ui?.root"
    :loading="loading"
    :show-header="showHeader"
    loader-border
    mobile-all-button
    :all-button="{
      label: 'Все ученики',
      to: '#',
    }"
  >
    <template #all-button>
      <UButton
        class="mr-8"
        trailing-icon="i-local-move-up-right"
        variant="outline"
        to="/trainers"
      >
        Все тренеры
      </UButton>
    </template>

    <template #default="{ slide }: { slide: any }">
      <CommonCard
        :item="slide"
        title-right="directions"
        image-top-left="directions"
        description-under-left="trainer"
        :ui="{
          title: 'max-md:line-clamp-2',
        }"
      />
    </template>
  </SPSliderSection>
</template>

<script lang="ts" setup>
import type { Slug } from '~/shared'

defineOptions({
  name: 'OurPrideSection',
})

const props = withDefaults(
  defineProps<{
    students?:
      | {
          name: string
          image_url: string
          description: string
          trainer: {
            id?: string
            name: string
          }
          directions: [
            {
              slug: Slug
              name: string
            },
          ]
        }[]
      | any[]
    title?: string
    loading?: boolean
    full?: boolean
    showHeader?: boolean
    ui?: {
      root?: string
      card?: string
      cardBody?: string
    }
  }>(),
  {
    title: 'Наша гордость',
    full: true,
    showHeader: true,
  },
)

const students = computed(() => props.students ?? [])
</script>

<style lang="scss" scoped>
:deep(.common-card) {
  --card-height: 416px;
  --card-image-height: 240px;

  :deep(.body-header) {
    margin-bottom: 12px;
  }

  @include max-xl {
    --card-height: 358px;
    --card-image-height: 200px;
  }

  @include max-md {
    --card-height: 330px;
    --card-image-height: 155px;
  }
}

:deep(.main-page-card) {
  // min-height: 498px;
  // height: 498px;
  --tw-ring-color: transparent;

  &:hover {
    .description,
    .buttons,
    .achievements {
      opacity: 1;
      max-height: 100px;
    }

    .info-header {
      margin-bottom: 12px;
    }
  }
}

:deep(.info) {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

:deep(.info-header) {
  opacity: 1;
  max-height: unset;
  margin-bottom: 12px;
}

@mixin hide {
  opacity: 0;
  max-height: 0px;
  overflow: hidden;
  transition: all 0.5s ease-in-out;
}

:deep(.buttons),
.achievements {
  @include hide;
}

:deep(.description) {
  @include max-md {
    // @include hide;
  }
}
</style>
